import { render } from "./About.vue?vue&type=template&id=f660e2d2&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=f660e2d2&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1117311187/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f660e2d2"]])

export default __exports__